// extracted by mini-css-extract-plugin
export default {"title":"_804d484f37","bld":"_63a8386ac7"};